import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { buildRealmPath } from '../shared/routing';
import NoMatch from './NoMatch';

// Wird getroffen, wenn die URL keinen (oder einen unbekannten) Realm-Präfix hat.
// Ist der Realm bereits bekannt (Login erfolgt), wird auf den realm-präfigierten
// Pfad umgeleitet, statt eine Fehlerseite zu zeigen.
const RealmRedirectOrNotFound = () => {
    const realm = useSelector((state) => state.theRealm);
    const location = useLocation();

    if (realm) {
        return <Navigate to={buildRealmPath(realm, location.pathname)} replace />;
    }

    return <NoMatch />;
};

export default RealmRedirectOrNotFound;
